import { Link } from "react-router-dom";

export default function CTASection({
  eyebrow,
  title,
  text,
  primaryLabel = "Find Your Learning Path",
  primaryTo = "/learning",
  secondaryLabel,
  secondaryTo,
  testId = "cta-section",
}) {
  return (
    <section className="no-print bg-navy" data-testid={testId}>
      <div className="container-x py-16 sm:py-24">
        <div className="mx-auto max-w-3xl text-center">
          {eyebrow && <p className="eyebrow-light">{eyebrow}</p>}
          <h2 className="mt-3 font-display text-2xl font-semibold leading-snug text-white sm:text-3xl lg:text-4xl">
            {title}
          </h2>
          <span className="gold-rule mx-auto mt-6" aria-hidden="true" />
          {text && <p className="mt-6 text-base leading-relaxed text-platinum md:text-lg">{text}</p>}
          <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to={primaryTo} className="btn-gold w-full sm:w-auto" data-testid={`${testId}-primary`}>
              {primaryLabel}
            </Link>
            {secondaryLabel && secondaryTo && (
              <Link to={secondaryTo} className="btn-outline-light w-full sm:w-auto" data-testid={`${testId}-secondary`}>
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
